import { render, staticRenderFns } from "./proflow.vue?vue&type=template&id=53ef620e&scoped=true"
import script from "./proflow.vue?vue&type=script&lang=js"
export * from "./proflow.vue?vue&type=script&lang=js"
import style0 from "./proflow.vue?vue&type=style&index=0&id=53ef620e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ef620e",
  null
  
)

export default component.exports